import LikeButtonSimpleMixin from 'modules/mixins/LikeButtonSimple';

export default class LikeButtonSimple {
  constructor() {
    document.addEventListener('DOMContentLoaded', this.initialize);
  }

  initialize() {
    const els = Array.from(document.querySelectorAll('.js-Like-Button-Simple'));
    if (!els[0]) {
      return;
    }
    els.forEach((el) => {
      new Vue({
        el,
        name: 'LikeButtonSimple',
        mixins: [LikeButtonSimpleMixin],
        mounted() {
          this.isClosed = this.$el.hasAttribute('data-is-closed');
          this.likableId = Number(this.$el.getAttribute('data-likable-id'));
          this.isLike = this.$el.getAttribute('data-is-like-default') === 'true';
          this.likableType = this.$el.getAttribute('data-likable-type');
          this.isSignedIn = this.$el.getAttribute('data-is-signed-in') === 'true';
          this.likeCount = Number(this.$el.getAttribute('data-like-count'));
        },
      });
    });
  }
}
